import { render, staticRenderFns } from "./CreateCedent.vue?vue&type=template&id=1a6f6c53&scoped=true&"
import script from "./CreateCedent.vue?vue&type=script&lang=js&"
export * from "./CreateCedent.vue?vue&type=script&lang=js&"
import style0 from "./CreateCedent.vue?vue&type=style&index=0&id=1a6f6c53&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f6c53",
  null
  
)

export default component.exports